import { cva } from 'class-variance-authority';

/** Warianty pola tekstowego. Osobny plik ze wzgledu na fast refresh. */
export const inputVariants = cva(
  [
    'w-full min-w-0 bg-surface-raised text-fg',
    'border border-border-input rounded-lg',
    'placeholder:text-fg-subtle',
    'transition-[border-color,box-shadow] duration-150',
    'focus-visible:border-brand focus-visible:ring-brand/35 focus-visible:ring-2 focus-visible:outline-none',
    'disabled:bg-surface-sunken disabled:text-fg-disabled disabled:cursor-not-allowed',
    'aria-invalid:border-danger-500 aria-invalid:focus-visible:ring-danger-500/30',
  ],
  {
    variants: {
      inputSize: {
        sm: 'h-9 px-3 text-[0.8125rem]',
        md: 'h-11 px-3.5 text-sm',
        lg: 'h-13 px-4 text-sm',
      },
    },
    defaultVariants: {
      inputSize: 'md',
    },
  },
);
